import { useEffect, useState } from 'react';

import { CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS } from '@domain/carRental/searchBar/list/constants';
import {
  CAR_RENTAL_SEARCH_DATE_FORMAT,
  convertDateToMomentObject,
} from '@utils/dateUtil';
import { useLocationSearchGet } from '@domain/carRental/searchBar/list/hooks';
import {
  DEFAULT_CAR_RENTAL_DROP_OFF_DATE,
  DEFAULT_CAR_RENTAL_DROP_OFF_TIME,
  DEFAULT_CAR_RENTAL_PICK_UP_DATE,
  DEFAULT_CAR_RENTAL_PICK_UP_TIME,
} from '@page/carRental/list/constants';

import { ICarRentalSearchBarState } from '../types/car';

// query : arac-kiralama/arama?pickUpLocation=YN1&pickUpDate=2023-12-05&pickUpTime=09%3A00&providerIds=d2cc5efe-f00d-46e9-9fd9-4144ba70faac-1&providerIds=f3cfc1ba-24a5-4559-b965-e5c832e91e47-1&dropOffLocation=AS2&dropOffTime=09%3A00&dropOffDate=2023-12-07
export const useCarRentalQuery = (query, enable) => {
  const [values, setValues] = useState<Partial<ICarRentalSearchBarState>>();

  const {
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.PICK_UP_LOCATION]: pickUpLocation,
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.DROP_OFF_LOCATION]: dropOffLocation,
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.PICK_UP_DATE]: pickUpDate,
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.DROP_OFF_DATE]: dropOffDate,
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.PICK_UP_TIME]: pickUpTime,
    [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.DROP_OFF_TIME]: dropOffTime,
  } = query;

  useLocationSearchGet({
    location: dropOffLocation,
    enabled: enable,
    onSuccess: (locations) => {
      if (locations?.length) {
        // set drop off locations for dropdown list
        setValues((oldValues) => ({
          ...oldValues,
          dropOffLocation: locations[0],
        }));
      }
    },
    onError: () => {
      setValues((oldValues) => ({
        ...oldValues,
        dropOffLocation: null,
      }));
    },
  });

  // ====================================
  // Get location search result for pick up location
  // ====================================

  useLocationSearchGet({
    location: pickUpLocation,
    onSuccess: (locations) => {
      if (locations?.length) {
        // set pick up locations for dropdown list
        setValues((oldValues) => ({
          ...oldValues,
          pickUpLocation: locations[0],
        }));
      }
    },
    onError: () => {
      setValues((oldValues) => ({
        ...oldValues,
        pickUpLocation: null,
      }));
    },
  });

  useEffect(() => {
    if (pickUpDate && dropOffDate) {
      setValues((previousValues) => ({
        ...previousValues,
        pickUpDate: convertDateToMomentObject(
          pickUpDate,
          CAR_RENTAL_SEARCH_DATE_FORMAT
        ),
        dropOffDate: convertDateToMomentObject(
          dropOffDate,
          CAR_RENTAL_SEARCH_DATE_FORMAT
        ),
      }));
    } else {
      setValues((previousValues) => ({
        ...previousValues,
        pickUpDate: DEFAULT_CAR_RENTAL_PICK_UP_DATE,
        dropOffDate: DEFAULT_CAR_RENTAL_DROP_OFF_DATE,
      }));
    }
  }, [pickUpDate, dropOffDate]);

  useEffect(() => {
    if (pickUpTime && dropOffTime) {
      setValues((previousValues) => ({
        ...previousValues,
        pickUpTime,
        dropOffTime,
      }));
    } else {
      setValues((previousValues) => ({
        ...previousValues,
        pickUpTime: DEFAULT_CAR_RENTAL_PICK_UP_TIME,
        dropOffTime: DEFAULT_CAR_RENTAL_DROP_OFF_TIME,
      }));
    }
  }, [pickUpTime, dropOffTime]);

  return values;
};
